/**
 * Automation-only probes not covered elsewhere in the fingerprint.
 * Emitted as top-level `automation` (no scoring — server derives signals).
 */

function detectStackCdp() {
  const prev = Error.prepareStackTrace;
  let invoked = false;
  try {
    Error.prepareStackTrace = function stackTraceOverride() {
      invoked = true;
      if (typeof prev === 'function') {
        return prev.apply(this, arguments);
      }
    };
    // eslint-disable-next-line no-unused-vars
    new Error('');
    return invoked;
  } catch {
    return false;
  } finally {
    try {
      Error.prepareStackTrace = prev;
    } catch {
      /* ignore restore failure */
    }
  }
}

function collectChromeOwnPropertyNames() {
  try {
    const chrome = window.chrome;
    if (chrome == null || typeof chrome !== 'object') return null;
    return Object.getOwnPropertyNames(chrome);
  } catch {
    return null;
  }
}

function buildAutomationPayload() {
  const stackCdp = detectStackCdp();
  const chromeOwnPropertyNames = collectChromeOwnPropertyNames();

  const out = { stackCdp };
  if (chromeOwnPropertyNames != null) {
    out.chromeOwnPropertyNames = chromeOwnPropertyNames;
  }
  return out;
}

export default async function collectAutomationSignals() {
  try {
    return buildAutomationPayload();
  } catch {
    return { stackCdp: false };
  }
}
